import { Component, OnInit, Inject } from '@angular/core';
import {
  CampusUnitsFaq,
  CampusUnitsCommunicationsDataService,
  IComponentHasChanges,
  CampusUnitsFaqSection
} from '../../../shared';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-new-question-dialog',
  templateUrl: './new-question-dialog.component.html',
  styleUrls: ['./new-question-dialog.component.scss']
})
export class NewQuestionDialogComponent
  implements OnInit, IComponentHasChanges {
  hasUnsavedChanges;
  unsavedMessage: string;
  section: CampusUnitsFaqSection;
  question: CampusUnitsFaq;
  questionForm: FormGroup;
  savingChanges = false;
  questionInput: CampusUnitsFaq;
  isNew: boolean;
  title: string;

  constructor(
    private formBuilder: FormBuilder,
    private communicationsService: CampusUnitsCommunicationsDataService,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {
    this.questionInput = data.question;
    this.isNew = data.isNew;
    this.section = data.section;
  }

  ngOnInit() {
    if (this.isNew) {
      this.title = 'New';

      this.questionForm = this.formBuilder.group({
        question: '',
        answer: ''
      });
    } else {
      this.title = 'Edit';
      this.questionForm = this.formBuilder.group({
        question: this.questionInput.question,
        answer: this.questionInput.answer
      });
    }
  }

  tinyMceInit = {
      height: 300,
      menubar: false,
      plugins: 'advlist autolink lists link image charmap preview anchor searchreplace wordcount visualblocks code fullscreen insertdatetime media table code help wordcount',
      toolbar:
        'insert | undo redo |  formatselect | bold italic backcolor  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | help',
  }

  save() {
    this.savingChanges = true;
    this.question = new CampusUnitsFaq();
    this.question.answer = this.questionForm.get('answer').value;
    this.question.question = this.questionForm.get('question').value;
    this.question.campusUnitsFaqSectionId = this.section.campusUnitsFaqSectionId;
    if (this.isNew) {
      this.communicationsService
        .createQuestion(this.question)
        .subscribe(results => {
          this.savingChanges = false;
          this.matDialog.closeAll();
        });
    } else {
      this.question.campusUnitsFaqId = this.questionInput.campusUnitsFaqId;
      this.communicationsService
        .updateQuestion(this.question)
        .subscribe(results => {
          this.savingChanges = false;
          this.matDialog.closeAll();
        });
    }
  }
}
